import { Controller } from '@hotwired/stimulus';
import { enter, leave } from 'el-transition';

export default class extends Controller {
	static targets = ['container', 'notification'];
	static values = { timeout: { type: Number, default: 5000 } };

	declare readonly containerTarget: HTMLElement;
	declare readonly notificationTarget: HTMLElement;
	declare readonly timeoutValue: number;

	private timer: ReturnType<typeof setTimeout> | undefined;

	connect() {
		this.containerTarget.classList.remove('hidden');
		enter(this.notificationTarget);
		this.timer = setTimeout(() => this.close(), this.timeoutValue);
	}

	disconnect() {
		if (this.timer) clearTimeout(this.timer);
	}

	close() {
		if (this.timer) clearTimeout(this.timer);
		Promise.all([leave(this.notificationTarget)]).then(() => {
			this.containerTarget.classList.add('hidden');
		});
	}
}
